import { render, staticRenderFns } from "./OsdiDropDown.vue?vue&type=template&id=6c28eff0&scoped=true&"
var script = {}
import style0 from "./OsdiDropDown.vue?vue&type=style&index=0&id=6c28eff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28eff0",
  null
  
)

export default component.exports